import { render } from "./Menu.vue?vue&type=template&id=2ced2606"
const script = {}

import exportComponent from "/Users/Carl/Develop/go/src/github.com/Soesah/bazaar.vrijeschoolmarelandleiden.nl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__